"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChangeOrder = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M17,5 L17,17.2955205 L19.1503387,15.1564808 C19.3462654,14.9615836 19.662963,14.9620007 19.8583756,15.1574133 C20.053222,15.3522598 20.053222,15.6681682 19.8583756,15.8630147 L16.5,19.2071068 L13.1504805,15.8641721 C12.9552185,15.669294 12.9549074,15.353023 13.1497855,15.157761 C13.3454645,14.9620817 13.6621003,14.9618891 13.8576694,15.156983 L16,17.2941081 L16,5 L17,5 Z M8.5,4.79289322 L11.8495195,8.13582791 C12.0447815,8.330706 12.0450926,8.646977 11.8502145,8.84223896 C11.6545355,9.03791833 11.3378997,9.0381109 11.1423306,8.84301697 L9,6.70589187 L9,19 L8,19 L8,6.70447951 L5.84966127,8.8435192 C5.65373458,9.03841639 5.33703701,9.03799927 5.1416244,8.84258665 C4.94677797,8.64774023 4.94677797,8.33183176 5.1416244,8.13698533 L8.5,4.79289322 Z" })));
};
ChangeOrder.displayName = 'ChangeOrder';
exports.default = ChangeOrder;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChangeOrder.js.map